<template src="./storicoOutput.html"></template>

<script>
import { get_storico_output } from "@/api/api.storicoOutput.js";
import { get_listaClienti } from "@/api/api.dati.js";
import CampoData from "@/components/cliente/CampoData.vue";

export default {
    components: { CampoData },

    data: () => ({
        loading: false,
        righe: [],
        clienti: [],
        search: "",

        filtro: {
            tipoCertificazione: "Tutti",
            companyCode: "",
            dataDa: null,
            dataA: null,
        },

        headers: [
            { text: "Tipo", value: "tipoCertificazione", sortable: false },
            { text: "Id", value: "idCommessa", sortable: false },
            { text: "Riferimento", value: "riferimento", sortable: false },
            { text: "Azienda", value: "ragioneSociale", sortable: false },
            { text: "Cliente", value: "cliente", sortable: false },
            { text: "Gruppi di prodotto", value: "gruppiProdotto", sortable: false },
            { text: "Essenze", value: "essenze", sortable: false },
            { text: "Dichiarazioni", value: "dichiarazioni", sortable: false },
            { text: "Terzisti", value: "terzisti", sortable: false },
            { text: "Data creazione", value: "dataCreazione", sortable: false },
            { text: "Data modifica", value: "dataModifica", sortable: false },
            { text: "Stato", value: "eliminato", sortable: false },
            { text: "Azioni", value: "azioni", sortable: false },
        ],
    }),

    methods: {
        async caricaDati() {
            this.loading = true;
            try {
                const res = await get_storico_output({
                    TipoCertificazione: this.filtro.tipoCertificazione,
                    CompanyCode: this.filtro.companyCode,
                    DataDa: this.filtro.dataDa,
                    DataA: this.filtro.dataA,
                });
                this.righe = res.data.map((r) => ({ ...r, rowKey: `${r.companyCode}-${r.tipoCertificazione}-${r.idCommessa}` }));
            } finally {
                this.loading = false;
            }
        },

        async caricaClienti() {
            const res = await get_listaClienti({ Cliente: true, Gruppo: "Tutti" });
            this.clienti = res.data;
        },

        apriCommessa(item) {
            const percorsi = { "FSC": "/registro/", "PEFC": "/registro-pefc/", "FSC-PERS": "/registro-pers/" };
            const path = percorsi[item.tipoCertificazione] || "/registro/";
            this.$router.push({
                path: path + item.companyCode,
                query: { apriCommessa: item.idCommessa, cliente: item.ragioneSociale },
            });
        },

        formattaData(data) {
            if (!data) return "";
            try {
                return this.$i2kFunctions.formatISODate(data.substring(0, 10));
            } catch {
                return data;
            }
        },
    },

    created() {
        if (this.role !== "admin") this.$router.push({ path: "/" });
    },

    async mounted() {
        await this.caricaClienti();
        await this.caricaDati();
    },

    computed: {
        role() {
            return this.$store.getters["user/getRole"];
        },

        clientiConTutti() {
            return [{ companyCode: "", ragioneSociale: "Tutti" }, ...this.clienti];
        },

        righeFiltrate() {
            if (!this.search) return this.righe;
            const q = this.search.toLowerCase();
            return this.righe.filter((r) => {
                const campi = [
                    r.tipoCertificazione, r.idCommessa, r.riferimento, r.ragioneSociale, r.cliente,
                    r.gruppiProdotto, r.essenze, r.dichiarazioni, r.terzisti,
                    this.formattaData(r.dataCreazione), this.formattaData(r.dataModifica),
                    r.eliminato ? "Eliminato" : "Attivo",
                ];
                return campi.some((v) => v !== null && v !== undefined && String(v).toLowerCase().includes(q));
            });
        },
    },
};
</script>
